export const mapProviders: { [x: string]: any } = {
  apple: { name: 'Apple Music', logo: '/logos/apple-tv.png' },
  hbo: { name: 'HBO Max', logo: '/logos/hbo.png' },
  movistar: { name: 'Movistar', logo: '/logos/movistar.png' },
  netflix: { name: 'Netflix', logo: '/logos/netflix.png' },
  primeVideo: { name: 'Prime Video', logo: '/logos/primevideo.png' },
  filmin: { name: 'FilmIn', logo: '/logos/filmin.png' },
  spotifyUrl: { name: 'Spotify', logo: '/logos/spotify.png' },
  appleMusicUrl: { name: 'Apple Music', logo: '/logos/applemusic.png' },
  androidUrl: { name: 'Android', logo: '/logos/android-store.png' },
  iosUrl: { name: 'iOS', logo: '/logos/apple-store.png' },
};

export const CDN = 'https://cdn.peoople.app';
